import { z } from "zod";

export const weddingInputSchema = z.object({
  partner1Name: z.string().min(1).max(80),
  partner2Name: z.string().min(1).max(80),
  story: z.string().max(4000).optional().or(z.literal("")),
  // Réglage compression : garder les fichiers d'origine des invités.
  keepOriginals: z.boolean().optional(),
});
export type WeddingInput = z.infer<typeof weddingInputSchema>;

export const updateWeddingSchema = weddingInputSchema.partial();
export type UpdateWeddingInput = z.infer<typeof updateWeddingSchema>;

/** Réordonnancement des photos du couple (slideshow d'accueil). */
export const reorderCouplePhotosSchema = z.object({
  orderedIds: z.array(z.string()).max(60),
});
export type ReorderCouplePhotosInput = z.infer<typeof reorderCouplePhotosSchema>;
